import { autoinject, bindable, bindingMode, transient } from 'aurelia-framework';
import { ValidateResult } from 'aurelia-validation';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { Layout } from 'Common/Layout/Layout';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { PromptController } from 'Code/Prompts/PromptController';
import { Router } from 'aurelia-router';
import { SaveProgress } from 'Code/Extension/Progress';
import { Toastr } from 'Code/Extension/Toastr';
import { Config, SchedulerObj } from 'Config';
import { ValidationHelper } from 'Code/Helpers/ValidationHelper';
import * as replace from 'gulp-replace';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { EventAggregator } from 'aurelia-event-aggregator';

@autoinject
export class HomePageBaseCustomElement extends BaseCustomElement {



    protected dataService: DataService = null;
    protected authService: AuthService = null;

    protected router: Router = null;
    protected promptController: PromptController = null;
    protected element: any = null;
    protected showPreviewModal: boolean = false;
    protected i18n: I18N = null;
    protected schema: Object = null;
    protected i18nLocale: string = null;
    protected ea: EventAggregator = null;
    protected subFilter1: any = null;

    private requestCounter: number = 0
    private filter1Data: any = null;
    private userName: string = null;
    private isLogged: boolean = false;

    constructor(dataService: DataService, element: Element, router: Router, promptController: PromptController, i18n: I18N, authService: AuthService, eventAggregator: EventAggregator) {
        super();

        this.dataService = dataService;
        this.element = element;
        this.router = router;
        this.promptController = promptController;
        this.i18n = i18n;
        this.authService = authService;
        this.ea = eventAggregator;

        this.userName = this.authService.GetUserInfo().UserName;
        this.isLogged = StringHelper.StringIs(this.userName) && this.userName != 'PublicUser';
    }

    async bind() {
    }

    async Filter1(data: any) {
        this.filter1Data = null;
        let params: any = JSON.parse(JSON.stringify(data));
        if (StringHelper.IsNullOrEmptyOrUndefined(params.FilterString)) {
            params.FilterString = '';
        }
        params.ClientCookie = Cookies.get('ccuid');
        this.requestCounter = this.requestCounter + 1;
        params.RequestCounter = this.requestCounter;

        let apiResponse: any = await this.dataService.GetSpData('sp_BirdReviewAircraftFilter', params);

        if (ObjectHelper.ObjectIs(apiResponse) && ObjectHelper.ObjectIs(apiResponse.data)
            && ObjectHelper.ObjectIs(apiResponse.data.ResponseCounter) && apiResponse.data.ResponseCounter > 0 && apiResponse.data.ResponseCounter == this.requestCounter) {
            console.log(5555, apiResponse.data);
            this.filter1Data = JSON.parse(JSON.stringify(apiResponse.data));
        }
    }

    async attached() {
        this.subFilter1 = this.ea.subscribe('filter1', async response => {
            //console.log(7777, 'ea filter1', response);
            if (ObjectHelper.ObjectIs(response)) {
                await this.Filter1(response);
            }
        });

        let filter1Data: any = { FilterString: '' };
        let filterString: string = SystemService.Instance.GetStorageItem(null, 'Filter1String');
        //console.log(11, filterString);
        if (StringHelper.StringIs(filterString)) {
            //console.log(12);
            filter1Data.FilterString = filterString;
            //console.log(13);
            SystemService.Instance.SetStorageItem(null, 'Filter1String', null);
            console.log(14, SystemService.Instance.GetStorageItem(null, 'Filter1String'));
        }
        //console.log(99999, 'attached', filter1Data, localStorage['Filter1Data']);
        await this.Filter1(filter1Data);
    }

    detached() {
        this.subFilter1.dispose();
    }


}

